import { Icon } from "@chakra-ui/icons";
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
} from "@chakra-ui/react";
import { FaSave } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  BLUEMONEDDBACKGROUND,
  BLUEMONEDDBUTTONS,
  REDMONEDD,
} from "../../../../constants/colors";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { goToListFavorites } from "../../../../routes/coordinator";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import { componentState } from "../../../../atoms/componentState";
import { useEffect, useState } from "react";
import FavoritesAPi from "../../../../services/favoritesApi";
import { cnpj as cnpjValidator, cpf as cpfValidator } from "cpf-cnpj-validator";
import SysTypesApi from "../../../../services/sysTypesApi";
import { PatternFormat } from "react-number-format";
import BankSelector from "../../../../defaultComponents/bankSelector";
import { JWTToken } from "../../../vendas/listaDeVendas/components/SalesList";
import jwt_decode from "jwt-decode";
import { selectedClientHeader } from "../../../../atoms/selectedClientHeader";
import { LoggedUser } from "../../../../atoms/userLogged";
import {
  CPFFormater,
  CNPJFormater,
  PhoneFormater,
  CaptionFormater,
} from "../../../../defaultFunctions/formaters";
export default function AddFavorites() {
  const navigate = useNavigate();
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  // const cliente = Number(jwtToken.idCliente);
  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const cliente =
    user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
  // const cliente = useRecoilState(LoggedUser)[0].id;
  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];
  const setHeaderLocation = useSetRecoilState(componentState);
  // const [cliente, setCliente] = useState(0);
  const largura = window.screen.width;

  useEffect(() => {
    setHeaderLocation("Cadastro de Favorecidos");
  }, []);

  interface IFormInputs {
    idCliente: number;
    idTipoConta: number;
    nomeTitular: string;
    docTitular: string;
    nroBanco: string;
    nroAgencia: string;
    nroConta: string;
    nroContaDigito: string;
    tipoChave: string;
    chavePix: string;
  }


  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm<IFormInputs>();

  const initialValues = {
    idCliente: 0,
    idTipoConta: 1,
    nomeTitular: "",
    docTitular: "",
    nroBanco: "",
    nroAgencia: "",
    nroConta: "",
    nroContaDigito: "",
    tipoChave: "",
    chavePix: "",
  };
  const [favored, setFavored] = useState<IFormInputs>(initialValues);

  async function addFavoriteAccount(obj: {}) {
    try {
      await FavoritesAPi.postFavorecido(obj);
      toast.success("Favorecido cadastrado com successo!");
      setRefreshGlobal(refresh + 1);
      goToListFavorites(navigate);
    } catch (error) {
      toast.error("Não foi possível cadastrar o favorecido.");
      console.log(error);
    }
  }
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFavored({ ...favored, [name]: value });
  };
  async function onSubmit() {
    const temp = unMask(favored.docTitular);
    if (temp != "" && !cnpjValidator.isValid(temp) && !cpfValidator.isValid(temp)) {
      setError("docTitular", {
        type: "onBlur",
        message: "Este CPF/CNPJ não é válido!",
      });
    } else {
      setError("docTitular", { type: "onBlur", message: "" });
      // console.log("error", errors.nroAgencia);
      if (!errors.nomeTitular?.message) {
        let objeto: any = {
          idCliente: cliente,
          nomeTitular: favored.nomeTitular,
          docTitular: unMask(favored.docTitular),
          nroBanco: favored.nroBanco,
          nroAgencia: favored.nroAgencia,
          nroAgenciaDigito: "D",
          nroConta: favored.nroConta,
          nroContaDigito: favored.nroContaDigito,
          tipoChave: favored.tipoChave,
          chavePix: ["CNPJ", "CPF", "CELULAR"].includes(favored.tipoChave)
            ? unMask(favored.chavePix)
            : favored.chavePix,
        };
        if (Number(favored.idTipoConta) > 0) {
          objeto.idTipoConta = Number(favored.idTipoConta);
        }
        addFavoriteAccount(objeto);
      } else {
        toast.error("Cadastre os 4 digitos na agência!");
      }
    }
  }
  const formatarChavePix = (chave: string, tipoChave: string) => {
    let chaveFormatada = favored.chavePix;
    switch (favored.tipoChave) {
      case "CPF":
        chaveFormatada = CPFFormater(chave);
        break;
      case "CNPJ":
        chaveFormatada = CNPJFormater(chave);
        break;
      case "CELULAR":
        chaveFormatada = PhoneFormater(chave);
        break;
      case "EVP":
      case "EMAIL":
        chaveFormatada = chave;
        break;
      default:
        break;
    }
    return chaveFormatada;
  };
  const unMask = (value: any) => {
    return value.replace(/[^0-9]/g, "");
  };

  function validateCNPJ(cnpj: any) {
    const temp = cnpj.match(/\d/g).join("");
    if (temp.length > 11) {
      if (!cnpjValidator.isValid(temp)) {
        setError("docTitular", {
          type: "onBlur",
          message: "Este CNPJ não é válido!",
        });
      } else {
        setError("docTitular", { type: "onBlur", message: "" });
      }
    } else {
      if (!cpfValidator.isValid(temp)) {
        setError("docTitular", {
          type: "onBlur",
          message: "Este CPF não é válido!",
        });
      } else {
        setError("docTitular", { type: "onBlur", message: "" });
      }
    }
  }

  const [types, setTypes] = useState([
    {
      id: 0,
      nome: "",
    },
  ]);

  const getTypeAccount = async () => {
    try {
      const response = await SysTypesApi.sysTypeAccount(1, 100, "");
      setTypes(response);
    } catch (error: any) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTypeAccount();
  }, []);

  return (
    <>
      <Flex
        w={"100%"}
        h={"100%"}
        alignItems="center"
        justifyContent="center"
        bg={"#F1F1F1"}
      >
        <Flex
          w={"95%"}
          h={"95%"}
          bgColor={BLUEMONEDDBACKGROUND}
          borderRadius={"20px"}
          justifyContent="center"
          alignItems={"center"}
        >
          <Flex
            w={"90%"}
            height="90%"
            flexDirection={"column"}
            justifyContent="space-evenly"
          >
            <Text
              fontWeight={"bold"}
              // fontSize="35px"
              color={"white"}
              fontSize={"2vw"}
            >
              CADASTRO DE FAVORECIDOS
            </Text>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl>
                <FormLabel color="white" fontSize={"1vw"}>
                  Coloque o nome do titular da Conta.
                </FormLabel>
                <Input
                  h={"2.5vw"}
                  fontSize={"1vw"}
                  mb={2}
                  type="text"
                  bg="white"
                  placeholder="Digite o nome do titular"
                  onChange={(e: any) => {
                    setFavored({ ...favored, nomeTitular: e.target.value });
                  }}
                />
                <Text color="red" mt="-3" mb={2}>
                  {errors.nomeTitular?.message}
                </Text>
                <Flex my={2} w="100%" justifyContent="space-between">
                  <FormControl w={"45%"}>
                    <FormLabel
                      fontWeight={"bold"}
                      fontSize={"16px"}
                      mt={2}
                      color="white"
                    >
                      Tipo de Chave do Favorecido{" "}
                      <span style={{ fontWeight: "normal", fontSize: "14px" }}>
                        (opcional)
                      </span>
                    </FormLabel>
                    <Select
                      onChange={(e) => {
                        setFavored({
                          ...favored,
                          tipoChave: e.target.value,
                        });
                      }}
                      value={favored.tipoChave}
                      backgroundColor="white"
                      placeholder="Escolha seu método (opcional)"
                    >
                      <option value="" disabled selected hidden>
                        ESCOLHA SEU MÉTODO
                      </option>
                      <option value="CPF">CPF</option>
                      <option value="CNPJ">CNPJ</option>
                      <option value="CELULAR">CELULAR</option>
                      <option value="EMAIL">EMAIL</option>
                      {/* <option value="EVP">CHAVE ALEATÓRIA</option> */}
                    </Select>
                  </FormControl>

                  <FormControl w={"45%"}>
                    <FormLabel
                      fontWeight={"bold"}
                      fontSize={"16px"}
                      mt={2}
                      color="white"
                    >
                      Chave do Favorecido{" "}
                      <span style={{ fontWeight: "normal", fontSize: "14px" }}>
                        (opcional)
                      </span>
                    </FormLabel>
                    <Input
                      backgroundColor="white"
                      type="text"
                      name="chavePix"
                      placeholder="Digite a chave para transferir (opcional)"
                      value={favored.chavePix}
                      onChange={handleInputChange}
                      onBlur={() => {
                        const chaveFormatada = formatarChavePix(
                          favored.chavePix,
                          favored.tipoChave
                        );
                        setFavored({
                          ...favored,
                          chavePix: chaveFormatada,
                        });
                      }}
                    />
                  </FormControl>
                </Flex>
              </FormControl>
              <Flex w="100%" justifyContent={"space-between"}>
                <FormControl w="45%">
                  <FormLabel color="white" fontSize={"1vw"}>
                    CPF ou CNPJ
                  </FormLabel>
                  <PatternFormat
                    h={"2.5vw"}
                    fontSize={"1vw"}
                    bg="white"
                    customInput={Input}
                    format={
                      unMask(favored.docTitular).length > 11
                        ? "##.###.###/####-##"
                        : "###.###.###-###"
                    }
                    type="text"
                    placeholder="Digite o CPF ou CNPJ"
                    value={favored.docTitular}
                    // {...register("cnpjDestinatario", { required: true })}
                    onChange={(e: any) => {
                      setFavored({ ...favored, docTitular: e.target.value });
                    }}
                    onBlur={(e: any) => {
                      e.target.value && validateCNPJ(e.target.value);
                    }}
                  />
                  <Text color="red" mb={2}>
                    {errors.docTitular?.message}
                  </Text>
                </FormControl>
                <FormControl w="45%">
                  <FormLabel color="white" fontSize={"1vw"}>
                    Banco
                  </FormLabel>
                  {/* <Box borderRadius={"6px"} bgColor={"white"} w="100%"> */}
                  <BankSelector banco={favored} setBanco={setFavored} />
                  {/* </Box> */}
                </FormControl>
              </Flex>
              <Flex w="100%" justifyContent={"space-between"}>
                <FormControl w="30%">
                  <FormLabel color="white" fontSize={"1vw"} display={"flex"}>
                    <Text>
                      Digite a Agência{" "}
                      <span style={{ fontWeight: "bold", color: "red" }}>
                        (sem Dígito)
                      </span>
                    </Text>
                  </FormLabel>
                  <Input
                    w={"12vw"}
                    h={"2.5vw"}
                    fontSize={"1vw"}
                    maxLength={4}
                    placeholder="NNNN"
                    minLength={4}
                    bg="white"
                    value={favored.nroAgencia}
                    onChange={(event: any) =>
                      setFavored({ ...favored, nroAgencia: event.target.value })
                    }
                    onBlur={(e: any) => {
                      e.target.value && e.target.value.length < 4
                        ? setError("nroAgencia", {
                          type: "onBlur",
                          message: "Agência deve conter 4 digitos",
                        })
                        : setError("nroAgencia", {
                          type: "onBlur",
                          message: "",
                        });
                    }}
                  />
                  {/* <PatternFormat
                      bg="white"
                      format={"####"}
                      placeholder="NNNN"
                      mask={["N", "N", "N", "N"]}
                      customInput={Input}
                      w={"12vw"}
                      h={"2.5vw"}
                      fontSize={"1vw"}
                      value={favored.nroAgencia}
                      onChange={(event: any) =>
                        setFavored({ ...favored, nroAgencia: event.target.value })
                      }
                    /> */}
                  <Text color="red" mb={2}>
                    {errors.nroAgencia?.message}
                  </Text>
                </FormControl>
                <Flex
                  width={"45vw"}
                  justifyContent={"space-evenly"}
                  alignItems={"center"}
                // bg={"yellow"}
                >
                  <FormControl>
                    <FormLabel color="white" fontSize={"1vw"} display={"flex"}>
                      <Text>
                        Digite o Número da Conta{" "}
                        <span style={{ fontWeight: "bold", color: "red" }}>
                          (sem Dígito)
                        </span>
                      </Text>
                    </FormLabel>
                    <Input
                      bg="white"
                      type="text"
                      maxLength={10}
                      w={"18vw"}
                      h={"2.5vw"}
                      fontSize={"1vw"}
                      mx={1}
                      placeholder="Digite o Número da conta"
                      value={favored.nroConta}
                      {...register("nroConta")}
                      onChange={(e: any) => {
                        setFavored({
                          ...favored,
                          nroConta: e.target.value,
                        });
                      }}
                    />
                    <Text color="red" mb={2}>
                      {errors.nroConta?.message}
                    </Text>
                  </FormControl>
                  <Text color={"white"} mt={5} mr={1}>
                    -
                  </Text>
                  <FormControl>
                    <FormLabel color="white" fontSize={"1vw"}>
                      <Text>
                        Digite{" "}
                        <span style={{ fontWeight: "bold", color: "red" }}>
                          somente o Dígito
                        </span>{" "}
                        da conta
                      </Text>
                    </FormLabel>
                    <Input
                      bg="white"
                      type="text"
                      maxLength={1}
                      mx={1}
                      h={"2.5vw"}
                      fontSize={"1vw"}
                      w={"50px"}
                      //   placeholder="Dígito"
                      value={favored.nroContaDigito}
                      {...register("nroContaDigito")}
                      onChange={(e: any) => {
                        setFavored({
                          ...favored,
                          nroContaDigito: e.target.value,
                        });
                      }}
                    />
                    <Text color="red" mb={2}>
                      {/* {errors.nroConta?.message} */}
                    </Text>
                  </FormControl>
                </Flex>
                <FormControl w="15%">
                  <FormLabel color="white" fontSize={"1vw"}>
                    Tipo de Conta
                  </FormLabel>
                  <Select
                    bg="white"
                    h={"2.5vw"}
                    fontSize={"1vw"}
                    onChange={(event: any) => {
                      if (event.target.value > 0) {
                        setFavored({
                          ...favored,
                          idTipoConta: event.target.value,
                        })
                      } else {
                        setFavored({
                          ...favored,
                          idTipoConta: 1,
                        })
                      }
                    }}
                  >
                    <>
                      <option value={1} selected>
                        Tipo de conta
                      </option>
                      {types &&
                        types.map((item: any) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.nome}
                            </option>
                          );
                        })}
                    </>
                  </Select>
                </FormControl>
              </Flex>

              <Flex
                justifyContent={"space-between"}
                w={largura < 900 ? "30vw" : "20vw"}
              >
                <Button
                  type="submit"
                  bgColor={BLUEMONEDDBUTTONS}
                  color="white"
                  h={"2.5vw"}
                  fontSize={"1vw"}
                  // isDisabled={
                  //   cliente != 0 &&
                  //   favored.docTitular != "" &&
                  //   favored.nomeTitular != "" &&
                  //   favored.nroAgencia != "" &&
                  //   favored.nroConta != "" &&
                  //   favored.nroContaDigito != "" &&
                  //   Number(favored.idTipoConta) != 0
                  //     ? false
                  //     : true
                  // }
                  isDisabled={
                    !((cliente > 0) &&
                      ((
                        favored.nomeTitular != "" &&
                        favored.tipoChave != "" &&
                        favored.chavePix != ""
                      ) || (
                          favored.nomeTitular != "" &&
                          favored.nroAgencia != "" && favored.nroAgencia.length >= 4 &&
                          favored.nroBanco != "" &&
                          favored.idTipoConta > 0 &&
                          favored.docTitular != ""
                        )))
                  }
                  onClick={() => {
                    onSubmit();
                  }}
                >
                  <Icon mr={2} as={FaSave} />
                  SALVAR
                </Button>
                <Button
                  h={"2.5vw"}
                  fontSize={"1vw"}
                  bgColor={REDMONEDD}
                  color="white"
                  onClick={() => goToListFavorites(navigate)}
                >
                  X CANCELAR
                </Button>
              </Flex>
            </form>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
}
